function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M293,505.78v-18h11.53l4.59,5.06v12.89Zm1-17v16l14.13,0V493.26l-4-4.44Z",
  transform: "translate(-293 -487.81)"
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  points: "15.83 5.75 10.71 5.75 10.71 0.69 11.71 0.69 11.71 4.75 15.83 4.75 15.83 5.75"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 2.97,
  y: 6.06,
  width: 4.03,
  height: 0.97
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 2.97,
  y: 10.06,
  width: 8.97,
  height: 0.97
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 2.97,
  y: 14.06,
  width: 8.97,
  height: 0.97
});

var SvgFilesListingFiles = function SvgFilesListingFiles(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "18px",
    fill: "#434546",
    "data-name": "Text icon",
    viewBox: "0 0 16.13 17.97",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilesListingFiles, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/files_listing_files.6a1fc667.svg";
export { ForwardRef as ReactComponent };